import DetailsBookingProvider from 'components/DetailsBookingProvider';
import LiveChat from 'components/LiveChat/LiveChat';
import withAuthentication from 'components/withAuthentication';
import LoadingPage from 'pages/LoadingPage';
import NotFoundPage from 'pages/NotFoundPage';
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import LoginPage from '../LoginPage';

const BookingAccessRoute = ({
  component: Component,
  retrieveBookingAuthMethod,
  hasFetchedBookingAuthMethod,
  isAuthenticating,
  isAuthenticated,
  isSSO,
  authMethod,
  hasInitializedSSO,
  ...routeProps
}) => {
  const { bookingId } = routeProps.computedMatch.params;

  useEffect(() => {
    retrieveBookingAuthMethod({ bookingId });
  }, [bookingId, retrieveBookingAuthMethod]);

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (!hasFetchedBookingAuthMethod || !authMethod) {
          return <LoadingPage />;
        }

        if (authMethod === 'unknown') {
          return <NotFoundPage />;
        }

        if (!isAuthenticated) {
          return <LoginPage data-testid="login-form" isSSO={isSSO} hasInitializedSSO={hasInitializedSSO} bookingId={bookingId} />;
        }

        return (
          <DetailsBookingProvider>
            <Component {...props} isSSO={isSSO} />
            <LiveChat />
          </DetailsBookingProvider>
        );
      }}
    />
  );
};

export default withAuthentication(BookingAccessRoute);
